import './_styles.scss'

export const Methods = ({
    show,
    selected,
    onSelect = () => {}
}) => {

    return show ? (
        <div className="methods">
            <div className="method-header">
                Choose your preferred payment method
            </div>
            <div
                className='method-card d-flex justify-content-between align-items-center'
                onClick = { () => onSelect('maya') }
            >
                <div>
                    <img
                        alt = ""
                        src = { require('./maya.jpg') }
                        className = "method-logo"
                    />
                    <br/>
                    <strong style={{fontSize: 12}}>
                        Credit and Debit Card
                    </strong>
                </div>
                <div>
                    <img
                        alt = ""
                        className = { `method-selected ${ selected === "maya" ? "show" : '' }` }
                        src = { require('./check.png') }
                    />
                </div>
            </div>
            <div
                className='method-card d-flex justify-content-between align-items-center'
                onClick={ () => onSelect("bank") }
            >
                <div className='method-header'>
                    Bank Deposit
                </div>
                <div>
                    <img
                        alt = ""
                        className = { `method-selected ${ selected === "bank" ? "show" : '' }` }
                        src = { require('./check.png') }
                    />
                </div>
            </div>
            <div
                className='method-card d-flex justify-content-between align-items-center'
                onClick={ () => onSelect("qrph") }
            >
                <div className='method-header'>
                    Paymaya/Gcash/QRPH
                </div>
                <div>
                    <img
                        alt = ""
                        className = { `method-selected ${ selected === "qrph" ? "show" : '' }` }
                        src = { require('./check.png') }
                    />
                </div>
            </div>
            {/* <div
                className='method-card d-flex justify-content-between align-items-center'
                onClick = { () => onSelect('paypal') }
            >
                <img
                    alt = ""
                    src = { require('./paypal-logo.png') }
                    className = "method-logo"
                />
                <div>
                    <img
                        alt = ""
                        className = { `method-selected ${ selected === "paypal" ? "show" : '' }` }
                        src = { require('./check.png') }
                    />
                </div>
            </div> */}
        </div>
    ) : null
}